import { render } from "./EmergencyButton.vue?vue&type=template&id=02fb5162"
import script from "./EmergencyButton.vue?vue&type=script&lang=js"
export * from "./EmergencyButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__